import { combineEpics } from 'redux-observable';
import { I18n as I } from 'react-redux-i18n';

import Api from 'lib/Api';
import ReduxHelper from 'lib/ReduxHelper';
import { BIDS_ACTION_TYPES as AT } from './Bids.actions';

export default combineEpics(
  ...ReduxHelper.createDefaultEpics(
    [AT.BID_TEMP_SELECT, Api.tempSelectBid],
    [
      AT.BID_CANCEL,
      Api.cancelBid,
      { successMessage: () => I.t('EPICS_BIDS_BID_CANCELED') },
    ]
  )
);
